
import React, { useState } from "react";
import { useSelector } from "react-redux";
import SRList from "../component/List";
import AkkhorLayout from "../layout/akkhor";
import { Link } from "react-router-dom";

export default function DanhSachLinkUV() {
    const { user } = useSelector((state) => state.auth);
    const [params, setParam] = useState('');
    const [fullname, setFullname] = useState('');
    const [code, setCode] = useState('');
    const [email, setEmail] = useState("");
    const [filterShow, setFilterShow] = useState(false)


    const handleSubmit = (e) => {
        e.preventDefault();
        let _param = ''
        if (fullname !== '') _param += "&fullname=" + fullname
        if (email !== '') _param += "&email=" + email
        // console.log(_param);
        setParam(_param);
    };

    let columns = [
        { name: "id", label: "ID", options: { filter: false, sort: true } },
        { name: "campaign_name", label: "Tên chiến dịch" },
        {
            name: "link", label: "Link",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return value ? <a className="text-danger" target="_blank" href={value}>{value}</a> : ''
                },
            }
        },
        {
            name: "department_id", label: "Phạm vi",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <>
                        {tableMeta.company_name ? <div>Công ty: <strong>{tableMeta.company_name}</strong></div> : ''}
                        {tableMeta.department_name ? <div>Đơn vị: <strong>{tableMeta.department_name}</strong></div> : ''}
                        {tableMeta.chucvu ? <div>Vị trí: <strong>{tableMeta.chucvu}</strong></div> : ''}
                    </>
                },
            }
        },

        {
            name: "status", label: "Trạng thái",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return value == 1 ? <span className="text-success">Đang hoạt động</span> : <span className="text-danger">Ngưng hoạt động</span>
                },
            }
        },
        { name: "author_name", label: "Người tạo" },
        { name: "datecreate", label: "Ngày tạo" },
    ];


    return (<AkkhorLayout idrole="users_new">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Danh sách link ứng viên
                </li>
            </ul>
        </div>

        <div className="card card-filter mb-3">
            <div className="card-header">
                <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
                    <div className="mr-auto">
                        <h3 className="title">Tìm kiếm</h3>
                    </div>
                    <button className="btn btn-sm btn-defaul"><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
                </div>
            </div>
            <div className={filterShow ? "card-body" : 'hidden-filter'}>
                <form className="new-added-form" method="get" >
                    <div className="row">
                        <div className="col-lg-2 col-md-6 col-sm-6 col-12 form-group">
                            <label>Tên nhân viên </label>
                            <input type="text" placeholder="Tìm theo tên" value={fullname} onChange={(e) => setFullname(e.target.value)} className="form-control height32" autoComplete="off" />
                        </div>
                        <div className="col-lg-2 col-md-6 col-sm-6 col-12 form-group">
                            <label>Mã nhân viên </label>
                            <input type="text" placeholder="Tìm theo mã nhân viên" value={code} onChange={(e) => setCode(e.target.value)} className="form-control height32" autoComplete="off" />
                        </div>
                        <div className="col-lg-2 col-md-6 col-sm-6 col-12 form-group">
                            <label>Email</label>
                            <input type="text" placeholder="Tìm theo email" value={email} onChange={(e) => setEmail(e.target.value)} className="form-control height32" autoComplete="off" />
                        </div>

                        <div className="col-12 ">
                            <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <SRList name="link_ungvien" idrole="users_new" params={params} title="Ứng viên" defaultLimit={20} serverSide={true} columns={columns} >
        </SRList>
    </AkkhorLayout>);
}
